import { Objects } from "@salaxy/core";

import { DateRangeController, InputBase } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Provides a user interface for picking up a date range
 * and optionally specifying also the number of working days within that range.
 * @example
 * ```html
 * <salaxy-date-range name="myDateRange" ng-model="temp" label="Sample date range"></salaxy-date-range>
 * ```
 */
export class DateRange extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",
    form: "?^^form",
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {
    /**
     * Label for the scondary input (Default: SALAXY.NG1.DateRange.labelDaysCount).
     * Translation is attempted.
     */
    labelDaysCount: "@",

    /**
     * The selection mode is either:
     *
     * - "range" for (default) calendar control with start and end.
     * - "calc" for period selection that is optimized for salary calculation (months, 2 weeks, 1/2 months etc.)
     */
    mode: "@",

    /**
     * Fires an event when the model is changing: Any of the values specific to the model are changing: start, end or daysCount.
     * This should typically used instead of ng-change because ng-change will only fire if the object reference changes.
     * On-change fires when dates or day count changes and this is typically what you are looking for.
     * @example <salaxy-date-range ng-model="$ctrl.dateRange" on-change="$ctrl.dateRangeChange()"></salaxy-date-range>
     */
    onChange: "&",

    /**
     * The data range values: start, end, daysCount and formattedDate.
     */
    dateRangeValues: "<"
  });

  /** Uses the DateRangeController */
  public controller = DateRangeController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/DateRange.html";
}